(() => {
  const roots = document.querySelectorAll('[data-article-top-nav]');

  roots.forEach((root) => {
    const toggle = root.querySelector('[data-atn-toggle]');
    const label = root.querySelector('[data-atn-label]');
    const menu = root.querySelector('[data-atn-menu]');

    if (!toggle || !menu) {
      return;
    }

    // Store event handler references for cleanup
    const onDocumentClick = (event) => {
      if (!root.contains(event.target)) {
        closeMenu();
      }
    };

    const onDocumentKeydown = (event) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    };

    const closeMenu = () => {
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      
      // Remove document-level event listeners when menu is closed
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onDocumentKeydown);
    };

    const openMenu = () => {
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      
      // Add document-level event listeners only when menu is open
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onDocumentKeydown);
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      root.classList.contains('is-open') ? closeMenu() : openMenu();
    });

    menu.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link) {
        return;
      }

      if (label) {
        label.textContent = link.textContent.trim();
      }

      closeMenu();
    });
  });
})();
